import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faMapMarkerAlt, faChevronDown, faBriefcase } from '@fortawesome/free-solid-svg-icons'; 

const JobCard = ({ job, handleApplyNow, isExpanded, onToggleExpand }) => {
  return (
    // The onClick handler is removed from the main div
    <div className={`job-card ${isExpanded ? 'expanded' : ''}`}>
      {/* The onClick handler is now on the header only */}
      <div className='expansion-area' onClick={() => onToggleExpand(job.id)}>
      <div className="job-card-header"  >
        <div className="job-card-title-and-description">
          <h4>{job.title}</h4>
          
        </div>
        
        <div className="header-right">
          <FontAwesomeIcon 
            icon={faChevronDown} 
            className={`accordion-arrow ${isExpanded ? 'rotated' : ''}`} 
          />
        </div>
      </div>
        {!isExpanded && (
            <p>
            {job.summary_description}
             </p>
          )}

      <div className="job-card-details">
        <div className="job-card-details-left">
          <span className="detail-tag">
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            {job.location}
          </span>
          <span className="detail-tag">
            <FontAwesomeIcon icon={faClock} />
            {job.job_type}
          </span>
              {job.experience_range && (
             <span className="detail-tag">
                <FontAwesomeIcon icon={faBriefcase} />
                {job.experience_range}
              </span>
          )}
        </div>
        <div className="job-card-details-right">
          <button className="apply-btn" onClick={(e) => { e.stopPropagation(); handleApplyNow(job.title); }}>
            Apply
          </button>
        </div>
      </div>
      </div>
      

      {isExpanded && (
        <div className="job-card-full-content">
          <h4>Requirements:</h4>
          <ul className="job-requirements-list">
            {job.requirements.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
          <h4>Roles and Responsibilities:</h4>
          <ul className="job-description-list">
            {job.description.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default JobCard;